export const stakeDuration = [
    { id: 1, value: 2, text: "3 Months" },
    { id: 2, value: 3, text: "6 Months" },
    { id: 3, value: 4, text: "9 Months" },
    { id: 4, value: 5, text: "12 Months" },
]